import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { getGqlQuery, constants } from 'common/helpers'
import request from 'sb-request'
import { getFeatureToggle } from 'helpers'


const {
  setProduct,
  setShouldBeShared,
  setIsFirstStep,
  setShouldSendProductId,
  setProductRating,
} = reducers.models.review


const fetchItems = (isContinue) =>
  request.get('rest/review/product', {
    query: {
      continue: isContinue,
    },
    // mock: true,
    // mockData: [
    //  {
    //    id: 715,
    //    brand: 'Berdoues',
    //    name: 'Assam of India',
    //    img: 'https://cdn.scentbird.com/perfume/normal/img-715.jpg',
    //    sex: 'female',
    //    category: 'Eau de Parfum',
    //    url: '/perfume/caron-pour-un-homme-de-caron-sport-609',
    //  },
    //  {
    //    id: 715,
    //    brand: 'Berdoues',
    //    name: 'Assam of India',
    //    img: 'https://cdn.scentbird.com/perfume/normal/img-715.jpg',
    //    sex: 'female',
    //    category: 'Eau de Parfum',
    //    url: '/perfume/caron-pour-un-homme-de-caron-sport-609',
    //  },
    //  {
    //    id: 715,
    //    brand: 'Berdoues',
    //    name: 'Assam of India',
    //    img: 'https://cdn.scentbird.com/perfume/normal/img-715.jpg',
    //    sex: 'female',
    //    category: 'Eau de Parfum',
    //    url: '/perfume/caron-pour-un-homme-de-caron-sport-609',
    //  },
    // ],
    modifyResult: ({ data }) => data,
  })
    .then((data) => {
      reducers.models.review.setItems(data)

      return data && data.length
    })

const fetchTags = ({ productId }) => {
  const { models: { me: { gender } } } = getState()

  return request.get('rest/review/tag', {
    query: {
      gender,
      productId,
    },
    // mock: true,
    // mockData: {
    //   'Scent type': [
    //     {
    //       type: 'Scent type',
    //       id: 36,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/floral.svg',
    //       name: 'Floral',
    //     }, {
    //       type: 'Scent type',
    //       id: 53,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/fruity.svg',
    //       name: 'Fruity',
    //     }, {
    //       type: 'Scent type',
    //       id: 2052,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/aquatic.svg',
    //       name: 'Aquatic',
    //     }, {
    //       type: 'Scent type',
    //       id: 132,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/woody.svg',
    //       name: 'Woody',
    //     }, {
    //       type: 'Scent type',
    //       id: 117,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/spicy.svg',
    //       name: 'Spicy',
    //     }, {
    //       type: 'Scent type',
    //       id: 185,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/citrusy.svg',
    //       name: 'Citrusy',
    //     },
    //   ],
    //   Occasion: [
    //     {
    //       type: 'Occasion',
    //       id: 2043,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/party.svg',
    //       name: 'Party',
    //     }, {
    //       type: 'Occasion',
    //       id: 2041,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/everyday.svg',
    //       name: 'Everyday',
    //     }, {
    //       type: 'Occasion',
    //       id: 2044,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/vacation.svg',
    //       name: 'Vacation',
    //     }, {
    //       type: 'Occasion',
    //       id: 2042,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/office.svg',
    //       name: 'Office',
    //     }, {
    //       type: 'Occasion',
    //       id: 2040,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/date_night.svg',
    //       name: 'Date Night',
    //     }, {
    //       type: 'Occasion',
    //       id: 2045,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/workout.svg',
    //       name: 'Workout',
    //     },
    //   ],
    //   Style: [
    //     {
    //       type: 'Style',
    //       id: 5,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/sexy.svg',
    //       name: 'Sexy',
    //     }, {
    //       type: 'Style',
    //       id: 58,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/elegant.svg',
    //       name: 'Elegant',
    //     }, {
    //       type: 'Style',
    //       id: 48,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/flirty.svg',
    //       name: 'Flirty',
    //     }, {
    //       type: 'Style',
    //       id: 84,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/sophisticated.svg',
    //       name: 'Sophisticated',
    //     }, {
    //       type: 'Style',
    //       id: 126,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/clean.svg',
    //       name: 'Clean',
    //     },
    //   ],
    //   Describe: [
    //     {
    //       type: 'Describe',
    //       id: 21,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/fresh.svg',
    //       name: 'Fresh',
    //     }, {
    //       type: 'Describe',
    //       id: 2056,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/powdery.svg',
    //       name: 'Powdery',
    //     }, {
    //       type: 'Describe',
    //       id: 2057,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/light.svg',
    //       name: 'Light',
    //     }, {
    //       type: 'Describe',
    //       id: 2060,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/warm.svg',
    //       name: 'Warm',
    //     }, {
    //       type: 'Describe',
    //       id: 33,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/clean.svg',
    //       name: 'Sweet',
    //     }, {
    //       type: 'Describe',
    //       id: 2059,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/strong.svg',
    //       name: 'Strong',
    //     },
    //   ],
    //   Season: [
    //     {
    //       type: 'Season',
    //       id: 2050,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/summer.svg',
    //       name: 'Summer',
    //     }, {
    //       type: 'Season',
    //       id: 2047,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/fall.svg',
    //       name: 'Fall',
    //     }, {
    //       type: 'Season',
    //       id: 2051,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/winter.svg',
    //       name: 'Winter',
    //     }, {
    //       type: 'Season',
    //       id: 2049,
    //       img: 'https://cdn.scentbird.com/assets/rate-icons-svg/spring.svg',
    //       name: 'Spring',
    //     },
    //   ],
    //   Complexity: [
    //     {
    //       type: 'Complexity',
    //       id: 2067,
    //       img: 'http://local.scentbird.com:8080/assets/rate-icons-svg/easy-going.svg',
    //       name: 'Easy-going',
    //     }, {
    //       type: 'Complexity',
    //       id: 2068,
    //       img: 'http://local.scentbird.com:8080/assets/rate-icons-svg/refined.svg',
    //       name: 'Refined',
    //     }, {
    //       type: 'Complexity',
    //       id: 2069,
    //       img: 'http://local.scentbird.com:8080/assets/rate-icons-svg/intense.svg',
    //       name: 'Intense',
    //     },
    //   ],
    // },
    modifyResult: ({ data }) => data,
  })
    .then((data) => {
      reducers.models.review.setTags(data)
    })
}

/**
 * This temporary method!
 *
 * @param {Number} productId
 *
 * @returns {Promise} request
 */
const fetchSkincareRecommendations = (productId) => {

  const params = {
    limit: 50,
    groups: [ 'BathBody' ],
  }

  return request.post('graphql?name=products', {
    body: {
      query: `{
        ${getGqlQuery('products', params)} {
          id
          img
          sex
          url
          name
          brand
          category
        }
      }`,
    },
    modifyResult: ({ products = [] }) => {
      if (!products) {
        return []
      }

      return products
        .filter(({ sex, id }) => sex === 'unisex' && id !== productId)
        .sort(() => Math.random() - 0.5)
        .slice(0, 8)
    },
  })
}

const fetchRecommendations = () => {
  const { models: { review: { shouldSendProductId, product: { id, rating } } } } = getState()
  const positiveRatingValue = 3

  return request.get('rest/user/recommendation', {
    query: {
      limit: 8,
      productId: shouldSendProductId && rating > positiveRatingValue ? id : null, // https://scentbird.atlassian.net/browse/SCNT-2835
    },
    // mock: true,
    // mockData: [
    //   {
    //     id: 38,
    //     name: 'Toujours Glamour',
    //     img: 'https://cdn.scentbird.com/perfume/normal/img-38.jpg',
    //     price: 0,
    //     volume: 0.0,
    //     description: `The fragrance is complex and what the wearer senses initially changes after an hour or so.
    //       This is a pleasant surprise that all women will like. This eau de toilette is a rich blend of quality notes.
    //       The top notes are red currant, violet leaf and cardamom. The heart notes are almond,
    //       lily of the valley and jasmine. The base notes are heliotrope, musk and benzoin.`,
    //     brand: 'moschino',
    //     tag1: 'Aquatic',
    //     tag2: 'Day',
    //     tag3: 'Elegant',
    //     sex: 'female',
    //     link: '/perfume/moschino-toujours-glamour-38',
    //   },
    //   {
    //     id: 38,
    //     name: 'Toujours Glamour',
    //     img: 'https://cdn.scentbird.com/perfume/normal/img-38.jpg',
    //     price: 0,
    //     volume: 0.0,
    //     description: `The fragrance is complex and what the wearer senses initially changes after an hour or so.
    //       This is a pleasant surprise that all women will like. This eau de toilette is a rich blend of quality notes.
    //       The top notes are red currant, violet leaf and cardamom. The heart notes are almond,
    //       lily of the valley and jasmine. The base notes are heliotrope, musk and benzoin.`,
    //     brand: 'moschino',
    //     tag1: 'Aquatic',
    //     tag2: 'Day',
    //     tag3: 'Elegant',
    //     sex: 'female',
    //     link: '/perfume/moschino-toujours-glamour-38',
    //   },
    //   {
    //     id: 38,
    //     name: 'Toujours Glamour',
    //     img: 'https://cdn.scentbird.com/perfume/normal/img-38.jpg',
    //     price: 0,
    //     volume: 0.0,
    //     description: `The fragrance is complex and what the wearer senses initially changes after an hour or so.
    //       This is a pleasant surprise that all women will like. This eau de toilette is a rich blend of quality notes.
    //       The top notes are red currant, violet leaf and cardamom. The heart notes are almond,
    //       lily of the valley and jasmine. The base notes are heliotrope, musk and benzoin.`,
    //     brand: 'moschino',
    //     tag1: 'Aquatic',
    //     tag2: 'Day',
    //     tag3: 'Elegant',
    //     sex: 'female',
    //     link: '/perfume/moschino-toujours-glamour-38',
    //   },
    //   {
    //     id: 38,
    //     name: 'Toujours Glamour',
    //     img: 'https://cdn.scentbird.com/perfume/normal/img-38.jpg',
    //     price: 0,
    //     volume: 0.0,
    //     description: `The fragrance is complex and what the wearer senses initially changes after an hour or so.
    //       This is a pleasant surprise that all women will like. This eau de toilette is a rich blend of quality notes.
    //       The top notes are red currant, violet leaf and cardamom. The heart notes are almond,
    //       lily of the valley and jasmine. The base notes are heliotrope, musk and benzoin.`,
    //     brand: 'moschino',
    //     tag1: 'Aquatic',
    //     tag2: 'Day',
    //     tag3: 'Elegant',
    //     sex: 'female',
    //     link: '/perfume/moschino-toujours-glamour-38',
    //   },
    // ],
    modifyResult: ({ data }) => data,
  })
}

/**
 * Add new review
 *
 * @param {Object} values
 * @param {String} values.productId
 * @param {String} values.text
 * @param {String} values.title
 * @param {Number} values.rating
 */
const add = ({ title, text, ageCategory, skinType, productId, rating }) => {
  const {
    models: {
      review: { shouldBeShared: { facebook, twitter } },
      facebook: { isInitialized },
    },
  } = getState()

  const isProductPageGQLEnabled = getFeatureToggle(constants.gqlFeatures.productPageGQL)

  const message = `${title} ${text}`

  if (twitter) {
    actions.misc.twitter.post(message)
  }

  if (facebook && isInitialized) {
    actions.models.facebook.share({ link: window.location.href, message })
  }

  if (isProductPageGQLEnabled) {
    const input = {
      productId,
      rating,
      title,
      text,
      ageCategory,
      skinType,
    }

    return request.post('graphql?name=createReview', {
      body: {
        query: `
          mutation {
            ${getGqlQuery('createReview', { input })} {
              id: reviewId
            }
          }
        `,
      },
      modifyResult: ({ createReview }) => createReview,
    })
      .then((response) => {
        setIsFirstStep(false)

        return response
      })
  }

  return request.post(`rest/product/${productId}/reviews`, {
    body: {
      text,
      title,
      rating,
      skinType,
      ageCategory,
    },
  })
    .then((response) => {
      setIsFirstStep(false)

      return response
    })
}

/**
 * Edit review
 *
 * @param {Object} values
 * @param {Object} values.review
 * @param {Number} values.productId
 * @param {Number} values.reviewId
 */
const edit = ({ review, productId, reviewId }) => {
  const {
    models: {
      review: { shouldBeShared: { facebook, twitter } },
      facebook: { isInitialized },
    },
  } = getState()

  const isProductPageGQLEnabled = getFeatureToggle(constants.gqlFeatures.productPageGQL)

  const { title, text, ageCategory, skinType, rating } = review

  const message = `${title} ${text}`

  if (twitter) {
    actions.misc.twitter.post(message)
  }

  if (facebook && isInitialized) {
    actions.models.facebook.share({ link: window.location.href, message })
  }

  if (isProductPageGQLEnabled) {
    const input = {
      productId,
      reviewId,
      rating,
      title,
      text,
      ageCategory,
      skinType,
    }

    return request.post('graphql?name=updateReview', {
      body: {
        query: `
          mutation {
            ${getGqlQuery('updateReview', { input })} {
              result
            }
          }
        `,
      },
    })
  }

  return request.post(`rest/product/${productId}/reviews/${reviewId}`, {
    body: review,
    formData: true,
  })
}

/**
 * Vote for tag
 *
 * @param {Number} productId
 * @param {String} tag
 * @param {Number} reviewId
 */
const vote = ({ productId, tag, reviewId }) =>
  request.post('rest/engine/perfume/reviewTagVote', {
    body: {
      perfumeId: productId,
      tag,
      reviewId,
    },
    multiple: true,
    formData: true,
  })


export default {
  fetchItems,
  fetchTags,
  fetchRecommendations,
  fetchSkincareRecommendations,
  setProduct,
  setShouldBeShared,
  setShouldSendProductId,
  setProductRating,
  setIsFirstStep,
  vote,
  edit,
  add,
}
